import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";


import FirstViewer from "./FirstViewer";
import SecondViewer from "./SecondViewer";
import ThirdViewer from "./ThirdViewer";
import MFViewer from "./MFViewer";
import LRRViewer from "./LRRViewer";
import MFZoomViewer from "./MFZoomViewer";



const App = () => {
  return (
    <BrowserRouter>
      <Routes>
     
        {/* <Route path="/" element={<SpaceViewer />} />
        <Route path="/first-floor" element={<SpaceViewer />} />
        <Route path="/m-floor" element={<MezzanineFloorViewer />} />
        <Route path="/second-floor" element={<SecondFloorViewer />} />
        <Route path="/third-floor" element={<ThirdFloorViewer />} />
        <Route path="/lrr" element={<LLR />} />
        <Route path="/mfc" element={<MFloorViewer />} /> */}
        {/* <Route path="/test" element={<SpaceViewer1 />} /> */}


        <Route path="/" element={<MFZoomViewer />} />
        <Route path="/first-floor" element={<FirstViewer />} />
        <Route path="/second-floor" element={<SecondViewer />} />
        <Route path="/third-floor" element={<ThirdViewer />} />
        <Route path="/m-floor" element={<MFViewer />} />
        <Route path="/lrr" element={<LRRViewer />} />
        <Route path="/mfc" element={<MFZoomViewer />} />


      </Routes>
    </BrowserRouter>
  );
};

export default App;